import { render, staticRenderFns } from "./ContentAuditView.vue?vue&type=template&id=6b539c5c&scoped=true"
import script from "./ContentAuditView.vue?vue&type=script&lang=js"
export * from "./ContentAuditView.vue?vue&type=script&lang=js"
import style0 from "./ContentAuditView.vue?vue&type=style&index=0&id=6b539c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b539c5c",
  null
  
)

export default component.exports